export const SHOW_REVIEWS_LIST_MINIMUM_REVIEWS = 1;

export const ORPHAN_REVIEW_COMPANY_ID = 'orphan';
